import { useCallback } from 'react';

/**
 * 日期工具 hook，提供日期格式化和相关功能
 */
export const useDateUtils = () => {
  /**
   * 将日期对象转换为 YYYY-MM-DD 格式的字符串
   */
  const formatDate = useCallback((date: Date): string => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }, []);

  /**
   * 获取今天的日期字符串 (YYYY-MM-DD)
   */
  const getTodayString = useCallback((): string => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return formatDate(today);
  }, [formatDate]);

  /**
   * 获取明天的日期字符串 (YYYY-MM-DD)
   */
  const getTomorrowString = useCallback((): string => {
    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return formatDate(tomorrow);
  }, [formatDate]);

  /**
   * 获取今天和明天的日期字符串数组
   */
  const getTodayTomorrowStrings = useCallback((): string[] => {
    return [getTodayString(), getTomorrowString()];
  }, [getTodayString, getTomorrowString]);

  return {
    formatDate,
    getTodayString,
    getTomorrowString,
    getTodayTomorrowStrings
  };
};
